import React, { useCallback } from 'react';

import DateRangeFilter from '@/components/FilterManager/DateRangeFilter';
import { DateFilter } from '@/types/schema';

import { DateRangeFilterProps } from './types';

function DateRangeFilterContainer(props: DateRangeFilterProps) {
  const { filter, setFilter, filterId, defaultPlaceholder, options, operators, selectedOperator } =
    props;
  const selecetedValue = filter[filterId] as DateFilter;

  const onChange = useCallback(
    (value?: DateFilter) => {
      setFilter({
        ...filter,
        [filterId]: value,
      });
    },
    [filter, setFilter, filterId],
  );

  return (
    <DateRangeFilter
      defaultPlaceholder={defaultPlaceholder}
      operators={operators}
      options={options}
      selectedOperator={selectedOperator}
      selectedValue={selecetedValue}
      onChange={onChange}
    />
  );
}

export default DateRangeFilterContainer;
